import React, { useEffect, useState } from "react";
import { Alert, Carousel } from "react-bootstrap";
import { AddToCartButton } from "../../../../../Components/AddToCartComponent";
import { LoadingComponent } from "../../../../../Components/Loading";
import { groupedProductValidator } from "../../../../../Helpers/validator";
import { Woo, createWooProduct } from "../../../../../Helpers/Woo";
import { VariableProductComponent } from "./__components/VariableProductComponent";
import { useTranslation } from "react-i18next";
import { StyledImageProduct, StyledTwoColumn } from "../../../style.css";
import parse from "html-react-parser";

export const GroupedProductLayout = ({ product }) => {
  const [bundledProducts, setBundledProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  const handleAddProductToBundle = (data, remove = false) => {
    let products = [];
    let inCart = false;
    for (const prod of selectedProducts) {
      if (prod.product.id !== data.id) {
        products.push(prod);
      } else {
        inCart = true;
      }
    }
    if (remove === false && inCart === false) {
      products.push(createWooProduct(data));
    }
    setSelectedProducts(products);
  };

  useEffect(() => {
    const groupedIds = Array.isArray(product.grouped_products)
      ? product.grouped_products
      : Object.values(product.grouped_products || {});

    if (!groupedIds.length) {
      setLoading(false);
      return;
    }

    Woo.products
      .findBy({ include: groupedIds.join(",") })
      .then(async (products) => {
        const orderedProducts = [];
        const productsIndex = {};

        for (let p of products) {
          if (p.name && typeof p.name === "object") {
            p = { ...p, name: Object.values(p.name)[0] || "" };
          }
          if (p.short_description && typeof p.short_description === "object") {
            p = { ...p, short_description: Object.values(p.short_description)[0] || "" };
          }
          productsIndex[p.id] = p;
        }

        for (const groupedProductId of groupedIds) {
          let prod = productsIndex[groupedProductId];
          if (prod) {
            orderedProducts.push(prod);
          }
        }

        setBundledProducts(orderedProducts);
        setLoading(false);

        const simpleProducts = [];
        for (const p of orderedProducts) {
          if ("simple" === p.type) {
            simpleProducts.push(createWooProduct(p));
          }
        }
        setSelectedProducts(simpleProducts);
      });
  }, []);

  if (loading) {
    return <LoadingComponent />;
  }

  const isProductSelected = (id) => {
    return selectedProducts.some((p) => p.product.id === id);
  };

  return (
    <StyledTwoColumn>
      <div>
        <Carousel
          data-bs-theme="dark"
          indicators={product.images && product.images.length > 1}
        >
          {product.images &&
            product.images.map((i) => (
              <Carousel.Item key={i.src}>
                <StyledImageProduct src={i.src} className="w-100 d-block" />
              </Carousel.Item>
            ))}
        </Carousel>
      </div>

      <div className="d-flex flex-column">
        <h1 className="h3 fw-bold mb-2">{t(product.name)}</h1>
        {product.short_description && (
          <div className="mb-3" id="product-desc">
            {parse(t(product.short_description))}
          </div>
        )}

        <h6 className="fw-bold mb-2">{t("Selecciona los productos:")}</h6>
        <div className="row g-2 mb-4">
          {bundledProducts.map((bundled) => {
            if ("variable" === bundled.type) {
              return (
                <div className="col-6" key={`product-${bundled.id}`}>
                  <VariableProductComponent
                    product={bundled}
                    selectProduct={handleAddProductToBundle}
                    isSelected={isProductSelected(bundled.id)}
                  />
                </div>
              );
            }

            if ("simple" === bundled.type) {
              const selected = isProductSelected(bundled.id);
              return (
                <div className="col-6" key={`product-${bundled.id}`}>
                  <BundledItem
                    name={t(bundled.name)}
                    price={bundled.price}
                    selected={selected}
                    onClick={() => {
                      if (selected) {
                        handleAddProductToBundle(bundled, true);
                      } else {
                        handleAddProductToBundle(bundled);
                      }
                    }}
                  />
                </div>
              );
            }

            return null;
          })}
        </div>

        {error && <Alert variant="danger">{error}</Alert>}
        <AddToCartButton
          originalProduct={product}
          product={product}
          bundledItems={selectedProducts}
          validator={groupedProductValidator}
          setError={setError}
        />
      </div>
    </StyledTwoColumn>
  );
};

function BundledItem({ name, price, selected, onClick }) {
  return (
    <div
      role="button"
      className={`p-3 border rounded-3 text-center h-100 position-relative ${
        selected ? "border-success bg-light" : ""
      }`}
      onClick={onClick}
      style={{ cursor: "pointer", transition: "all 0.15s ease" }}
    >
      {selected && (
        <span
          className="position-absolute top-0 end-0 mt-1 me-2 text-danger fw-bold"
          style={{ fontSize: "1.1rem", lineHeight: 1 }}
        >
          &times;
        </span>
      )}
      <span className={`small ${selected ? "fw-bold" : ""}`}>{name}</span>
      <div className="mt-1">
        <span className="fw-medium text-muted small">
          {parseFloat(price) > 0 ? `${parseFloat(price).toFixed(2)}€` : ""}
        </span>
      </div>
    </div>
  );
}
